/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import {
  func, arrayOf, string, shape, bool, oneOfType, node, number,
} from 'prop-types';
import { connect } from 'react-redux';

import { isEmpty, uniq } from 'lodash';
import { Scrollbars } from 'react-custom-scrollbars';
import {CircularProgress, Paper, IconButton } from '@material-ui/core';
import { Search, Clear } from '@material-ui/icons';

import FormDialog from '../FormDialog';
import CategoriesCheckboxTree from '../CategoriesCheckboxTree';
import ListCheckboxComponent from '../ListCheckbox';
import IntlMessages from '../../utils/IntlMessages';
import { scopeValidations } from './utils/validations';
import checkValidations from '../../utils/validator';
import InputErrors from '../InputErrors';

import { fetchRecursiveParentCategories } from '../../actions/scopeCategory';

const ScopeDialog = (props) => {
  const [errors, setErrors] = useState({});
  const [query, setQuery] = useState('');
  const [selected, setSelected] = useState([]);
  const [multipleSelected, setMultipleSelected] = useState([]);
  const [isSubmited, setIsSubmited] = useState(false);
  const [keyboardKey, setKeyboardKey] = useState('');

  useEffect(() => {
    const payload = props.selectedTreeItems.map((c) => {
      if (typeof c === 'string') return c;
      return c.id;
    });
    setSelected(payload);
    setMultipleSelected(payload);
  }, [props.showScopeDialog, props.selectedTreeItems]);

  useEffect(() => {
    if (
      props.showScopeDialog
      && !isEmpty([...props.selectedTreeItems, ...selected])
      && !props.scopeCategory.fetchingParentCatrgoiresByIds
      && isEmpty(props.search.list)
    ) {
      const payload = [...props.selectedTreeItems, ...selected].map((c) => {
        if (typeof c === 'string') return c;
        return c.id;
      });
      const categoriesIds = uniq(payload);

      if (!isEmpty(categoriesIds)) {
        props.fetchRecursiveParentCategories(categoriesIds);
      }
    }
  }, [props.showScopeDialog, props.search.list]);

  useEffect(() => {
    if (isEmpty(query) && keyboardKey === 'Backspace' && isSubmited) {
      setSelected([]);
      setIsSubmited(false);
      setKeyboardKey('');
      if (props.onToggleTree) props.onToggleTree();
    }
  }, [keyboardKey, query, props.search, isSubmited]);

  const clearData = () => {
    setQuery('');
    setKeyboardKey('');
    setIsSubmited(false);
    if (props.onToggleTree) props.onToggleTree(isSubmited);
  };

  const handleOnTreeSelect = (itemId) => {
    let selectedList = [...selected];

    if (!itemId) return setSelected([]);

    if (!selectedList.some((treeElId) => treeElId === itemId)) {
      selectedList.push(itemId);
    } else {
      selectedList = selectedList.filter((elId) => elId !== itemId);
    }

    return setSelected(selectedList);
  };

  const handleSearchTreeSelect = (itemId) => {
    const selectedList = [...selected
      .map((el) => (el && typeof el === 'string' ? el : el.id)), ...multipleSelected];
    const itemAlreadyExist = selectedList.some((s) => (s.id || s) === itemId);

    if (!itemAlreadyExist) {
      const payload = [
        ...selected,
        { id: itemId },
      ];

      setSelected(payload);
      setMultipleSelected(payload.map((p) => (p.id || p)));
    } else {
      setSelected(selected.filter((s) => (s.id || s) !== itemId));
      setMultipleSelected(multipleSelected
        .filter((s) => (s.id || s) !== itemId)
        .map((p) => (p.id || p)));
    }
  };

  const handleMultipleSelect = (itemsIds) => {
    setMultipleSelected(itemsIds);
  };

  const closeScopeDialog = () => {
    setSelected([]);
    setQuery('');
    props.closeScopeDialog();
  };

  const onSubmit = () => {
    if (props.checkStrictly) props.onSubmit([...selected]);
    else props.onSubmit([...multipleSelected]);
    props.onToggleTree();
    setQuery('');
  };

  const handleOnCategorySearch = (e) => {
    const { value } = e.target;
    setQuery(value);
  };

  const handleOnCategoryKeyPress = (e) => {
    const { search } = props;
    const { value } = e.target;
    const { charCode } = e;

    handleOnCategorySearch(e);

    if (charCode === 13 && value && value.length <= search.queryLengthLimit) {
      if (props.onSearchSubmit) {
        const newErrors = checkValidations(scopeValidations, { searchCategories: value });

        setIsSubmited(true);
        setSelected([]);
        setKeyboardKey('');
        setErrors(newErrors);
        if (isEmpty(newErrors)) props.onSearchSubmit(value);
      }
    }
  };

  // const handleOnCategoryKeyDown = (e) => {
  //   const { which, altKey } = e;
  //   if (
  //     (
  //       (which === 8 && e.target.value && e.target.value.length === 1)
  //       || (which === 8 && altKey)
  //       || (which === 13 && e.target.value)
  //     )
  //     && isSubmited
  //   ) {
  //     props.onToggleTree();
  //     setKeyboardKey(e.key);
  //   }
  // };

  const handleOnCategoryKeyDown = (e) => {
    const { which } = e;
    if (which === 8 && isSubmited) {
      setKeyboardKey(e.key);
    }
  };

  const handleOnSearchSubmit = () => {
    const { search } = props;
    if (query && query.length <= search.queryLengthLimit) {
      const newErrors = checkValidations(scopeValidations, { searchCategories: query });

      setErrors(newErrors);
      if (props.onSearchSubmit && isEmpty(newErrors)) {
        props.onSearchSubmit(query);
      }
    }
  };

  const {
    showScopeDialog,
    handleToggleCollapse,
    collapsed,
    treeItems,
    isRadio,
    dialog,
    search,
    multiple,
    loadAllChildCategories,
    extraClassName,
    showSecondaryTitle,
    loading,
  } = props;

  const treeSecondaryTitleClassName = showSecondaryTitle ? 'rct-with-secondary-title' : '';
  const loadingClass = loading ? 'disabled-list' : '';

  const useTreeComponent = (search.list && isEmpty(search.list))
    || (props.initOpen && !isEmpty(search.list));

  const disabledClass = loading ? 'disabled' : '';

  return (
    <FormDialog
      className={`scope-dialog ${extraClassName}`}
      open={showScopeDialog}
      title={dialog.title}
      closeButtonTitle={dialog.closeButtonTitle}
      submitButtonTitle={dialog.submitButtonTitle}
      onClose={closeScopeDialog}
      onSubmit={onSubmit}
      disabledFooter={loading}
    >
      <Paper className={`${loadingClass} flex items-center mb-15 pos-rel ${disabledClass}`} elevation={1}>
        {search.noResult && (
          <span className="input-placeholder">
            <IntlMessages id="productsHistory.scopeDialog.placeholder.noResult" />
          </span>
        )}
        {search.errorMessage && (!isEmpty(query) && query.length > search.queryLengthLimit) && (
          <span className="input-placeholder">
            <IntlMessages id={search.errorMessage} />
          </span>
        )}
        <input
          className="form-control form-control-clear block pl-15"
          placeholder={search.placeholder}
          onChange={handleOnCategorySearch}
          onKeyPress={handleOnCategoryKeyPress}
          onKeyDown={handleOnCategoryKeyDown}
          name="searchCategories"
          value={query}
        />
        {!isEmpty(query) && (
          <IconButton aria-label="Search" onClick={clearData}>
            <Clear />
          </IconButton>
        )}
        <IconButton aria-label="Search" onClick={handleOnSearchSubmit}>
          {loading ? <CircularProgress size={24} value={75} /> : <Search />}
        </IconButton>
      </Paper>
      {
        errors.searchCategories && !Array.isArray(errors)
        && (
          <InputErrors errors={errors.searchCategories} />
        )
      }
      <Scrollbars
        className="rct-scroll rct-scroll-gray"
        autoHeight
        autoHeightMin={300}
        autoHeightMax={600}
        autoHide
      >
        {
          useTreeComponent && !isSubmited
            ? (
              <CategoriesCheckboxTree
                isRadio={isRadio}
                className={`tree-wrapper-secondary ${loadingClass} ${treeSecondaryTitleClassName} ${disabledClass}`}
                categories={treeItems}
                selected={selected}
                collapsed={collapsed}
                onSelect={handleOnTreeSelect}
                onMultipleSelect={handleMultipleSelect}
                onToggleCollapse={handleToggleCollapse}
                loadChildren={props.fetchChildScopeCategories}
                checkedKeys={props.checkStrictly
                  ? selected
                  : multipleSelected}
                multiple={multiple}
                checkable
                loadAllChildCategories={loadAllChildCategories}
                showSecondaryTitle={showSecondaryTitle}
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...props}
              />
            )
            : (
              <ListCheckboxComponent
                className={`list-checkbox-wrapper list-checkbox-sm ${treeSecondaryTitleClassName} ${disabledClass}`}
                isRadio={isRadio}
                list={search.list}
                enabledHoverEffects={showSecondaryTitle}
                selected={props.checkStrictly
                  ? selected
                  : multipleSelected}
                onChange={!props.checkStrictly
                  ? handleSearchTreeSelect
                  : handleOnTreeSelect}
              />
            )
        }
      </Scrollbars>
    </FormDialog>
  );
};

ScopeDialog.propTypes = {
  fetchChildScopeCategories: func,
  handleToggleCollapse: func,
  closeScopeDialog: func,
  onSubmit: func.isRequired,
  onToggleTree: func,
  showScopeDialog: bool,
  collapsed: arrayOf(string),
  isRadio: bool,
  treeItems: arrayOf(shape({
    id: string,
  })),
  dialog: shape({
    title: oneOfType([string, node]),
    closeButtonTitle: oneOfType([string, node]),
    submitButtonTitle: oneOfType([string, node]),
  }),
  search: shape({
    list: arrayOf(shape({
      id: string,
    })),
    placeholder: string,
    errorMessage: string,
    queryLengthLimit: number,
  }),
  onSearchSubmit: func.isRequired,
  multiple: bool,
  loadAllChildCategories: func,
  checkStrictly: bool,
  initOpen: bool,
  showSecondaryTitle: bool,
  extraClassName: string,
  loading: bool,
  selectedTreeItems: arrayOf(oneOfType([string, shape()])),
  fetchRecursiveParentCategories: func.isRequired,
  scopeCategory: shape().isRequired,
};

ScopeDialog.defaultProps = {
  fetchChildScopeCategories: null,
  onToggleTree: null,
  closeScopeDialog: null,
  handleToggleCollapse: null,
  showScopeDialog: false,
  collapsed: [],
  treeItems: [],
  isRadio: false,
  dialog: {
    title: '',
    closeButtonTitle: 'Close',
    submitButtonTitle: 'Submit',
  },
  search: {
    placeholder: 'Search',
    noResult: bool,
    errorMessage: '',
    queryLengthLimit: null,
  },
  multiple: false,
  loadAllChildCategories: null,
  checkStrictly: true,
  initOpen: false,
  showSecondaryTitle: true,
  extraClassName: '',
  loading: false,
  selectedTreeItems: [],
};

const mapStateToProps = ({
  scopeCategory,
}) => ({
  scopeCategory,
});

export const actionCreators = {
  fetchRecursiveParentCategories,
};

export default connect(mapStateToProps, actionCreators)(ScopeDialog);
